import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom'
import {withCookies} from 'react-cookie';
import {withStyles} from '@material-ui/core/styles';
import PrivateRoute from "./components/dispatch/PrivateRoute";
import LoginForm from './components/dispatch/LoginForm';
import Top from "./components/dispatch/Top";
import DispatchRequestList from "./components/dispatch/DispatchRequestList";
import DispatchRequestDetail from "./components/dispatch/DispatchRequestDetail";
import SelectPompSpec from "./components/dispatch/SelectPompSpec";
import SelectDeliveryPeriod from "./components/dispatch/SelectDeliveryPeriod";
import SelectBusinessPartner from "./components/dispatch/SelectBusinessPartner";
import SubmitRequestDispatch from "./components/dispatch/SubmitRequestDispatch";
import SetNonDispatchableNum from "./components/dispatch/SetNonDispatchableNum";
import NotFound from "./components/dispatch/NotFound";
import UploadConstructionPlan from "./components/plantManagement/UploadConstructionPlan";
import DownloadConstructionPlan from "./components/plantManagement/DownloadConstructionPlan";
import DeleteConstructionPlan from "./components/plantManagement/DeleteConstructionPlan";
import SelectConstructionPlan from "./components/plantManagement/SelectConstructionPlan";
import LayoutEditor from "./components/plantManagement/LayoutEditor";
import Logout from "./components/dispatch/Logout";
import HeaderBar from "./components/HeaderBar";
import LicensePage from "./components/LicensePage";
import MfaRegister from './components/dispatch/MfaRegister';
import Mfa from './components/dispatch/Mfa';
import CancelRequestList from './components/dispatch/CancelRequestList';
import CancelRequestDetail from './components/dispatch/CancelRequestDetail';

const styles = () => ({
    footer: {
        padding: '40px'
    }
});

export class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            screenName: '',
            plantManagementFlag: false,
            isNoHeaderAndFooter: false,
        };

        this.onScreen = this.onScreen.bind(this);
    }

    onScreen(screenName, plantManagementFlag, isNoHeaderAndFooter) {
        // 第二引数が渡されなければ'plantManagementFlag'が"undefined"になるためサービス名は「ジェット配車サービス」となる.
        // 第三引数が渡されなければ'isNoHeaderAndFooter'が"undefined"になるためヘッダー(AppBar)とフッター(footer)は有りとなる.
        this.setState({screenName: screenName, plantManagementFlag: plantManagementFlag, isNoHeaderAndFooter: isNoHeaderAndFooter});
    }

    render() {
        return (
            <div className="App">
                {
                    !this.state.isNoHeaderAndFooter &&
                    <HeaderBar
                        cookies={this.props.cookies}
                        serviceName={this.state.plantManagementFlag ? '洗浄場管理' : 'ジェット配車サービス'}
                        screenName={this.state.screenName}
                    />
                }
                <Switch>
                    <Route path='/login' render={({...props}) => <LoginForm {...props} cookies={this.props.cookies} onScreen={this.onScreen}/>}/>
                    <Route path='/logout' render={({...props}) => <Logout {...props} backPath='/login' cookies={this.props.cookies} onScreen={this.onScreen}/>}/>
                    <Route path='/mfa/register' render={({...props}) => <MfaRegister {...props} cookies={this.props.cookies} onScreen={this.onScreen}/>}/>
                    <Route path='/mfa' render={({...props}) => <Mfa {...props} cookies={this.props.cookies} onScreen={this.onScreen}/>}/>
                    <Route
                        path='/license'
                        component={({ ...props }) => (
                            <LicensePage
                                {...props}
                            />
                        )}
                    />
                    <PrivateRoute exact path='/' component={Top} cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/setNonDispatchableNum' component={SetNonDispatchableNum} backPath='/' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/dispatchRequestList' component={DispatchRequestList} backPath='/' detailPath='/dispatchRequestDetail' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/dispatchRequestDetail' component={DispatchRequestDetail} backPath='/dispatchRequestList' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/selectPompSpec' component={SelectPompSpec} backPath='/' nextPath='/selectDeliveryPeriod' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/selectDeliveryPeriod' component={SelectDeliveryPeriod} backPath='/selectPompSpec' nextPath='/selectBusinessPartner' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/selectBusinessPartner' component={SelectBusinessPartner} backPath='/selectDeliveryPeriod' nextPath='/submitRequestDispatch' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/submitRequestDispatch' component={SubmitRequestDispatch} backPath='/selectBusinessPartner' nextPath='/dispatchRequestList' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/uploadCsv' component={UploadConstructionPlan} backPath='/' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/downloadCsv' component={DownloadConstructionPlan} backPath='/' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/deleteCsv' component={DeleteConstructionPlan} backPath='/' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/selectCsv' component={SelectConstructionPlan} backPath='/' nextPath='/editLayout' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/editLayout' component={LayoutEditor} backPath='/selectCsv' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <PrivateRoute path='/cancelRequestList' component={CancelRequestList} backPath='/' detailPath='/cancelRequestDetail' cookies={this.props.cookies} onScreen={this.onScreen} />
                    <PrivateRoute path='/cancelRequestDetail' component={CancelRequestDetail} backPath='/cancelRequestList' nextPath='/cancelRequestList' cookies={this.props.cookies} onScreen={this.onScreen}/>
                    <Route component={NotFound} onScreen={this.onScreen}/>
                </Switch>
                {
                    this.state.isNoHeaderAndFooter ? <div/> : <footer className={this.props.classes.footer}/>
                }
            </div>
        );
    }
}

export default withStyles(styles)(withCookies(App));
